<div class="frame-in">
  <div  [ngClass]="{'hidden': loading}" >


    <div class="set-avatar">
      <button type="button" class="back-button" (click)="previousState()"></button>


      @if (userInfo) {
        <div class="in-box">
          <div class="big-avatar">
            <img [src]="'assets/images/avatar/avatars/big/'+ selectedAvatar + '.png'" alt="{{userInfo.name}}">
            <button type="button" class="done" (click)="done()"
            [ngClass]="{'set': userInfo.avatar == selectedAvatar}"></button>
          </div>
          <div class="avatar-list">
            @if (userInfo.sex == 'male') {
              <ul class="boys">
                <li>
                  <button type="button" class="b6" (click)="selectedAvatar = 'b6'"
                  [ngClass]="{'active': selectedAvatar == 'b6'}"></button>
                </li>
                <li>
                  <button type="button" class="b5" (click)="selectedAvatar = 'b5'"
                  [ngClass]="{'active': selectedAvatar == 'b5'}"></button>
                </li>
                <li>
                  <button type="button" class="b4" (click)="selectedAvatar = 'b4'"
                  [ngClass]="{'active': selectedAvatar == 'b4'}"></button>
                </li>
                <li>
                  <button type="button" class="b3" (click)="selectedAvatar = 'b3'"
                  [ngClass]="{'active': selectedAvatar == 'b3'}"></button>
                </li>
                <li>
                  <button type="button" class="b2" (click)="selectedAvatar = 'b2'"
                  [ngClass]="{'active': selectedAvatar == 'b2'}"></button>
                </li>
                <li>
                  <button type="button" class="b1" (click)="selectedAvatar = 'b1'"
                  [ngClass]="{'active': selectedAvatar == 'b1'}"></button>
                </li>
              </ul>
            }
            @if (userInfo.sex == 'female') {
              <ul class="girls">
                <li>
                  <button type="button" class="g6" (click)="selectedAvatar = 'g6'"
                  [ngClass]="{'active': selectedAvatar == 'g6'}"></button>
                </li>
                <li>
                  <button type="button" class="g5" (click)="selectedAvatar = 'g5'"
                  [ngClass]="{'active': selectedAvatar == 'g5'}"></button>
                </li>
                <li>
                  <button type="button" class="g4" (click)="selectedAvatar = 'g4'"
                  [ngClass]="{'active': selectedAvatar == 'g4'}"></button>
                </li>
                <li>
                  <button type="button" class="g3" (click)="selectedAvatar = 'g3'"
                  [ngClass]="{'active': selectedAvatar == 'g3'}"></button>
                </li>
                <li>
                  <button type="button" class="g2" (click)="selectedAvatar = 'g2'"
                  [ngClass]="{'active': selectedAvatar == 'g2'}"></button>
                </li>
                <li>
                  <button type="button" class="g1" (click)="selectedAvatar = 'g1'"
                  [ngClass]="{'active': selectedAvatar == 'g1'}"></button>
                </li>
              </ul>
            }
          </div>
          <div class="sex-box">
            <button type="button" class="male" (click)="setGender('male')"
            [ngClass]="{'active': userInfo.sex == 'male'}"></button>
            <button type="button" class="female" (click)="setGender('female')"
            [ngClass]="{'active': userInfo.sex == 'female'}"></button>
          </div>
        </div>
      }

    </div>

    <img class="frame-bg" src="assets/images/avatar/bg.jpg" (loadeddata)="instructionLoaded()">
  </div>
</div>